import React, { useState, useRef } from 'react';
import { Col, Container, Row , FormGroup, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Input, Select, Checkbox } from 'antd';
import { Breadcrumb, MainHeader, MainFooter, ImageElement } from "../../components";
import { Link } from "react-router-dom";


function SuperFan() {
    const breadcrumb = [
        {
            path: '/Home',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Become A Super Fan',
        },
    ]; 

    const [show, setShow] = useState(false);
    const target = useRef(null);

    return (
        <>  
            <MainHeader />
            <main className="becomePage becomePage_fan">
                <Container>
                    <Breadcrumb title="Become A Super Fan" breadcrumb={breadcrumb}/>
                    <div className="becomePage_inner">
                        <div className="becomePage_signup text-left">
                            <div className="becomePage_head mb-0">
                            <h2 className="mb-md-3 mb-1 font-sm">SIGN UP</h2>
                            </div>
                            <p>Thank you for your interest in becoming a Super Fan or Referral Partner.</p>
                            <p>Good Guys works hard everyday to provide the best service and value to our customers. To help reduce our cost, we created our Promo Code program. The Promo Code program has already saved customers money and provided returns for our super fans and referral partners!</p>
                            <h3>How it works is simple!</h3>
                            <ul className="list-unstyled">
                                <li>Sign up with some basic information (We confirm your account in less than 24 hours)</li>
                                <li>Submit a 5-8 digit Promo Code</li>
                                <li>Provide this promo code to anyone who could use our service.</li>
                                <li>Have them download our app or create an account online and enter your promo code.</li>
                                <li>Have them download our app or create an account online and enter your promo code.</li>
                                <li>The customer will save money for using the discount associated with the promo code and you will earn money every time they use our service.</li>
                            </ul>
                            <p>Added bonus! That promo code is saved in their profile forever! The customer will receive the savings and you will be compensated every time it is used! You earn money! Customer with your codes save money and receives the highest level of 5 star service! Get started today and tell us a bit about yourself.</p>
                        </div>
                        <div className="becomePage_steps">                           
                            <div className="becomePage_steps_form w-100 mx-auto">
                                {/* Create an Account */}
                                <div className="becomePage_steps_items">
                                   <h4>Create an Account</h4>
                                   <Row>
                                        <Col sm={6}>
                                            <FormGroup className="form-group">
                                                <label className="ant-label">Email ID<span className="text-650">*</span></label>
                                                <Input size="large" placeholder="Email ID" value="john@mailinator.com"/>
                                            </FormGroup>
                                        </Col>
                                        <Col sm={6}>
                                            <FormGroup className="form-group">
                                                <label className="ant-label">Password<span className="text-650">*</span></label>
                                                <Input size="large" type="password" placeholder="Password" value=""/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                                {/* Promo Code Good Guys Affiliate Information */}
                                <div className="becomePage_steps_items">
                                   <h4>Promo Code Good Guys Affiliate Information</h4>
                                   <Row>
                                        <Col sm={6}>
                                            <FormGroup className="form-group">
                                                <label className="ant-label">Your Name Or Company Name<span className="text-650">*</span></label>
                                                <Input size="large" placeholder="Your Name Or Company Name" value="2016"/>
                                            </FormGroup>
                                        </Col>
                                        <Col sm={6}>
                                            <FormGroup className="form-group">
                                                <label className="ant-label">Country<span className="text-650">*</span></label>
                                                <Select size="large" className="w-100" placeholder="Select"
                                                    defaultValue="1"
                                                    options={[
                                                        {
                                                            value: '1',
                                                            label: 'United States',
                                                        },
                                                        {
                                                            value: '2',
                                                            label: 'India',
                                                        }
                                                    ]}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={6}>
                                        <FormGroup className="form-group">
                                            <label className="ant-label d-flex">Good Guys Location To Support<span className="text-650">*</span>
                                             <div className='toolTip'>
                                                <OverlayTrigger
                                                        key='top'
                                                        placement='top'
                                                        overlay={
                                                            <Tooltip id='tooltip-top'>
                                                            Which Good Guys location could you help the most. If you can support all please select USA.
                                                            </Tooltip>
                                                        }
                                                        >
                                                    <Link to="#" ref={target} onClick={() => setShow(!show)}>
                                                    <em className="gg-info ms-2"/>
                                                    </Link>
                                                </OverlayTrigger>
                                                                                               
                                            </div>
                                             </label>
                                                {/* <label className="ant-label">Location</label> */}
                                                <Select
                                                    defaultValue="address1"
                                                    className="w-100"
                                                    size="large"
                                                    placeholder="Select Location"
                                                    options={[
                                                        {
                                                            value: 'address2',
                                                            label: 'Gita Bhawan',
                                                        },
                                                        {
                                                            value: 'address1',
                                                            label: 'Westfield Indiana',
                                                        },
                                                        {
                                                            value: 'address3',
                                                            
                                                            label: 'Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India',
                                                        }
                                                    ]}
                                                    />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={6}>
                                            <FormGroup className="form-group form-group-number">
                                                <label className="ant-label d-flex">Mobile Number<span className="text-650">*</span></label>
                                                <div className='position-relative'>
                                                <Input size="large" value="1234567890" placeholder="Number" />
                                                <div className="form-cstm position-absolute top-0 left-0 d-flex">
                                                    <Select size="large" className="w-100" placeholder="+91"
                                                        options={[
                                                            {
                                                                value: 'India',
                                                                label: '+91',
                                                            }
                                                        ]}
                                                    />
                                                </div>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                                {/* Enter Captcha  */}
                                <div className="becomePage_steps_items">
                                   <h4>Enter Captcha</h4>
                                   <Row>
                                        <Col sm={12}>                                    
                                            <FormGroup className="form-group mb--sm-3">
                                                <label className="ant-label d-flex">Captcha<span className="text-650">*</span></label>
                                                <Row className="align-items-center g-0">
                                                    <Col xs={6}><Input size="large" placeholder=""/></Col>
                                                    <Col xs={6}><div className="aboutPage_form_captxt">Gh3gjs</div></Col>
                                                </Row>
                                            </FormGroup>
                                        </Col>
                                        <Col sm={12}>
                                            <FormGroup className="form-group">
                                                <div className="aboutPage_form_link">
                                                    Can’t read the image? <Link to="/become-a-super-fan">Click here</Link>
                                                </div>                                        
                                            </FormGroup> 
                                        </Col>
                                        <Col sm={12}>
                                            <div className="authPage_to p_terms mb-xl-4 mb-3">
                                                <Checkbox>Agree To </Checkbox><Link to="/terms-conditions" className="forgotxt mb-0 link-500">Terms & Conditions</Link>
                                            </div>
                                        </Col>
                                        <Col sm={12}>
                                            <div className="d-flex justify-content-end">
                                                <Link to="/affiliate-login" className="min-200 me-3 btn btn-light">BACK</Link>
                                                <Link to="/store-profile" className="min-200 btn btn-primary">SUBMIT</Link>                                                
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>                            
                        </div>
                    </div>                   
                </Container>
            </main>  
            <MainFooter />
        </>
    );
  }
  
  export default SuperFan;